import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

const ResourceSectionTitleRightAlignedCTA = ({ data }) => {
    const { additionalConfiguration, backgroundColor, cardItem, customId } = data ?? {};
    const { title, cta } = cardItem ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-15");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container">
                <div className="md:flex md:justify-between">
                    {title && (
                        <h2
                            className={`${sectionColorMapping.primaryTextColor} text-center md:text-left md:col-6 lg:col-7`}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                    )}
                    {cta && (
                        <div className="flex gap-3.75 flex-wrap justify-center my-5 md:col md:justify-end md:pl-3.75 md:mb-0 md:mt-2.5 items-end">
                            {cta.map((singleCta) => (
                                <Cta key={singleCta.id} data={singleCta} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ResourceSectionTitleRightAlignedCTA;
